import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'sentinel.containers.app.loading',
    defaultMessage: 'Loading...',
  },
  title: {
    id: 'sentinel.containers.app.title',
    defaultMessage: 'Transfer Processing',
  },
  insufficientPermissions: {
    id: 'sentinel.containers.app.insufficientPermissions',
    defaultMessage: "You do not have permission to use Transfer Processing UI. Please contact Support if you'd like permission granted.",
  },
});



// WEBPACK FOOTER //
// ./src/containers/App/messages.js